module.exports = require('./helpers/bundle-url').getBundleURL('dgt5F') + "arrow_down.fbe43fd1.svg";